import React from 'react';
import { History, Search, Package, Calendar } from 'lucide-react';
import Pagination from '../../components/Layout/Pagination';

function HistoryTab({
  items, totalItems, currentPage, setCurrentPage, searchTerm, setSearchTerm, setSelectedItem,
  selectedYear, setSelectedYear, selectedMonth, setSelectedMonth
}) {
  return (
    <div className="bg-slate-900 rounded-[40px] shadow-2xl border border-blue-500/10 overflow-hidden">
      <div className="p-8 border-b border-white/5 flex flex-col lg:flex-row justify-between items-center gap-6">
        <div className="font-black text-2xl flex items-center gap-3 text-emerald-400 shrink-0"><History size={28}/> Sotuv Tarixi</div>

        <div className="flex flex-1 gap-4 items-center w-full lg:w-auto">
          <div className="flex items-center gap-2 bg-slate-950 px-4 py-2 rounded-2xl border border-white/5">
             <Calendar size={16} className="text-slate-500" />
             <select
                className="bg-transparent border-none font-bold text-xs outline-none text-white cursor-pointer"
                value={selectedYear}
                onChange={e => setSelectedYear(e.target.value)}
              >
                {[2026, 2027, 2028].map(y => <option key={y} value={y}>{y}</option>)}
              </select>
              <select
                className="bg-transparent border-none font-bold text-xs outline-none text-white cursor-pointer"
                value={selectedMonth}
                onChange={e => setSelectedMonth(e.target.value)}
              >
                {["Yan", "Fev", "Mar", "Apr", "May", "Iyun", "Iyul", "Avg", "Sen", "Okt", "Noy", "Dek"].map((m, i) => (
                  <option key={i+1} value={i+1}>{m}</option>
                ))}
              </select>
          </div>

          <div className="relative flex-1">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" size={18}/>
            <input type="text" placeholder="Sotuvdan qidirish..." className="w-full pl-12 pr-6 py-4 bg-slate-950 border border-white/5 rounded-[25px] outline-none focus:ring-2 focus:ring-emerald-500/20 font-bold text-white" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
          </div>
        </div>
      </div>
      <table className="w-full text-left">
        <thead className="bg-black/20 text-[10px] font-black uppercase text-slate-500">
          <tr><th className="px-10 py-5">Mahsulot</th><th className="px-10 py-5 text-center">Manba</th><th className="px-10 py-5 text-center">Sana</th><th className="px-10 py-5 text-right">Sotuv Narxi</th><th className="px-10 py-5 text-right text-emerald-400">Foyda (Sof)</th></tr>
        </thead>
        <tbody className="divide-y divide-white/5 text-slate-300">
          {items.map((i, idx) => {
            const salePrice = Number(i.sale_price || 0);
            const costPrice = Number(i.cost_price || 0);
            // Net profit logic: 27% tax deduction if salePrice > 0
            const profit = salePrice > 0 ? Math.round((salePrice - costPrice) * 0.73) : 0;

            return (
              <tr key={idx} className="hover:bg-emerald-600/5 transition cursor-pointer group" onClick={() => setSelectedItem(i)}>
                <td className="px-10 py-6">
                  <div className="flex items-center gap-4">
                    {i.image_url ? (
                      <img src={i.image_url} alt="p" className="w-10 h-10 rounded-lg object-cover border border-white/5" />
                    ) : (
                      <div className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center text-slate-600 border border-white/5"><Package size={16}/></div>
                    )}
                    <div>
                      <div className="font-bold text-slate-200">{i.product_name}</div>
                      <div className="mt-1 flex flex-col">
                         <div className="text-[10px] font-mono leading-none">
                            <span className="text-blue-400">{(i.marking_code || '').substring(0, 31)}</span>
                            <span className="text-slate-600">{(i.marking_code || '').substring(31)}</span>
                         </div>
                         {(i.marking_code || '').length > 31 && (
                            <div className="text-[9px] text-slate-700 font-mono opacity-50 mt-0.5">
                               {(i.marking_code || '').includes('91') ? `(91) qismi mavjud` : ""}
                            </div>
                         )}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-10 py-6 text-center">
                  <span className={`px-3 py-1 rounded-lg text-[9px] font-black uppercase tracking-widest ${i.sale_source === 'kassa' ? 'bg-amber-500/10 text-amber-400 border border-amber-500/20' : 'bg-blue-500/10 text-blue-400 border border-blue-500/20'}`}>
                    {i.sale_source === 'kassa' ? '🧾 KASSA' : '📱 APP'}
                  </span>
                </td>
                <td className="px-10 py-6 text-center">
                  <div className="flex flex-col items-center">
                    <div className="text-xs text-slate-500 font-bold">{new Date(i.sold_at).toLocaleString()}</div>
                    <div className="text-[10px] font-mono mt-1 overflow-hidden max-w-[200px] truncate">
                       <span className="text-blue-500/50">{(i.marking_code || '').substring(0, 31)}</span>
                    </div>
                  </div>
                </td>
                <td className="px-10 py-6 text-right">
                  <div className="flex flex-col items-end">
                    <div className="font-bold text-lg text-white">
                      {salePrice > 0 ? `${salePrice.toLocaleString()} s` : <span className="text-rose-500 font-black text-xs animate-pulse underline decoration-dotted">Narx yo'q</span>}
                    </div>
                    {(i.marking_code || '').length > 31 && (
                      <div className="text-[9px] font-mono text-slate-600 mt-1 overflow-hidden max-w-[150px] truncate">{(i.marking_code || '').substring(31)}</div>
                    )}
                  </div>
                </td>
                <td className="px-10 py-6 text-right font-black text-emerald-400 tracking-tight drop-shadow-[0_0_5px_rgba(16,185,129,0.3)]">
                  {salePrice > 0 ? `+${profit.toLocaleString()} s` : <span className="text-slate-600">--</span>}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Pagination totalItems={totalItems} itemsPerPage={50} currentPage={currentPage} onPageChange={setCurrentPage} />
    </div>
  );
}

export default HistoryTab;
